import { render, staticRenderFns } from "./HomeMainCards.vue?vue&type=template&id=d886ba3a&"
import script from "./HomeMainCards.vue?vue&type=script&lang=ts&"
export * from "./HomeMainCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports